import { useEffect } from 'react';
import { inflect } from '/src/utils/string';
import { useLockBodyScroll } from '/src/hooks';

import { ReactComponent as StarIcon } from '@crazyegginc/hatch/dist/images/icon-star-filled.svg';

export function OnboardingHeatmapsCreatedModal({ count, onHide }) {
  useLockBodyScroll();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onHide?.();
    }, 5000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [onHide]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onHide?.();
    }

    if (event.key === 'Escape') {
      onHide?.();
    }
  };

  return (
    <div
      className="fixed left-0 top-0 z-50 flex h-[100dvh] w-[100dvw] cursor-pointer items-center justify-center overflow-hidden overscroll-none bg-white/90 px-4 py-4"
      onClick={onHide}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <div className="flex max-h-full w-full max-w-[480px] flex-col items-center justify-center gap-7 sm:-translate-y-1/2">
        <div id="heatmap_stars" className="relative w-[180px] h-[70px]">
          <StarIcon className="absolute w-10 h-10 text-dandelion-500 fill-current left-1/2 -translate-x-1/2" />
          <StarIcon className="absolute w-[18px] h-[18px] text-[#B2BAC7] fill-current top-[35px] left-[22px]" />
          <StarIcon className="absolute w-[18px] h-[18px] text-[#B2BAC7] fill-current top-[35px] right-[22px]" />
          <StarIcon className="absolute w-3 h-3 text-[#B2BAC7] fill-current bottom-0 left-0" />
          <StarIcon className="absolute w-3 h-3 text-[#B2BAC7] fill-current bottom-0 right-0" />
        </div>
        <div
          className="flex max-h-[calc(100dvh-8rem)] w-full flex-col gap-3 overflow-y-auto overscroll-contain rounded border border-mystic-500 bg-white p-5 shadow-md sm:max-h-none sm:p-[30px]"
          onClick={(e) => {
            e.stopPropagation();
            onHide?.();
          }}
          onKeyDown={handleKeyDown}
          role="button"
          tabIndex={0}
        >
          <h2 className="text-2xl font-bold leading-9 text-black-pearl-500">
            {count} Heatmap {inflect('Report', count)} were created!
          </h2>

          <p className="text-base leading-6 text-lynch-500">
            Tracking has started so you can view Heatmaps and Session Recordings for your visitors. You should see data
            within a couple hours.
          </p>

          <p className="text-base leading-6 text-lynch-500">
            In the meantime, view real-time traffic in <strong>Web Analytics</strong> or <strong>Live Activity</strong>
          </p>
        </div>
      </div>
    </div>
  );
}
